import { configureStore } from '@reduxjs/toolkit';

import appReducer from "../reducers/appSlice";
import organizationReducer from "../reducers/organizationSlice"
import utilityReducer from '../reducers/utilitySlice'
import usersReducer from '../reducers/userSlice';
import discountsReducer from '../reducers/discountSlice';
import accessReducer from '../reducers/accessSlice';
export const store = configureStore({
  reducer: {
    app: appReducer,
    orgs: organizationReducer,
    users: usersReducer,
    utilities: utilityReducer,
    discounts: discountsReducer,
    access: accessReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store